import axios from 'axios'

export default {
    namespaced: true,
    state: {
        //cname: sessionStorage.getItem('cname') ? sessionStorage.getItem('cname') : '',
        cname: null,
        account_id: '',
    },

    mutations: {
        SET_CNAME(state, cname){
            state.cname = cname;
        }
    },
    actions: {
        async getCname({ commit, rootState }, account_id) {

            const apiPreUrl = rootState.url.apiPreUrl;
            const fronUrl = rootState.url.frontPreUrl;

            try {
                const params = {
                    account_id: account_id,
                    // ip: process.env.VUE_APP_FRONT_PRE_URL
                    ip: fronUrl
                };
                // const response = await axios.get(process.env.VUE_APP_API_PRE_URL + `/api/getCname`, {
                const response = await axios.get(apiPreUrl + `/api/getCname`, {
                    params,
                    //headers: { 'Authorization': `Bearer ${token}` }
                });
                
                sessionStorage.setItem('cname', response.data.cname);
                commit('SET_CNAME', response.data);
                return response.data;
            } catch (error){
                console.log(error);
            }
        },
    },

    getters: {
        cname: state => state.cname,
    }
}